import * as React from "react";
import classNames from "classnames";
import "./Text.scss";

type Props = {
  children: React.ReactNode;
  size?: "base" | "medium" | "small";
  bold?: boolean;
  italic?: boolean;
  inline?: boolean;
}

type Ref = HTMLParagraphElement;

const Text = React.forwardRef<Ref, Props>(({children, size= "base", bold= false, italic= false, inline= false}, ref) => {
  const className = classNames("nimbus-web--text", `nimbus-web--text--${size}`, { "nimbus-web--text--bold": bold }, { "nimbus-web--text--italic": italic }, { "nimbus-web--text--inline": inline });
  return (
    <p ref={ref} className={className}>{children}</p>
  );
});

export default Text;